import { createContext, Dispatch, SetStateAction } from 'react'

import { Role, RoleFilterKeyString } from 'Attendances/types'

type CustomFormRoleSelectionDrawerManagerContextType = {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedRole: Role
  setSelectedRole: (newRole: Role) => void
  filter: RoleFilterKeyString
  setFilter: Dispatch<SetStateAction<RoleFilterKeyString>>
  questionKey: string
  roles: Role[]
  loadingRoles: boolean
  setLoadingRoles: Dispatch<SetStateAction<boolean>>
}

const defaultValue = {
  view: '',
  setView: () => {},
  selectedRole: {},
  setSelectedRole: () => {},
  filter: {},
  setFilter: () => {},
  questionKey: '',
  roles: [],
  loadingRoles: false,
  setLoadingRoles: () => {},
}

const CustomFormRoleSelectionDrawerManagerContext =
  createContext<CustomFormRoleSelectionDrawerManagerContextType>(defaultValue)

export default CustomFormRoleSelectionDrawerManagerContext
